import { UserSlice } from "@/lib/redux/slices/userSlice/types";

export type TrackEvent =
  | { event: "sign_up"; method: string; user_email: string }
  | { event: "trial_started"; trial_ends_at: string }
  | { event: "login" }
  | { event: "whatsapp_cta_clicked"; cta_type: "demo" | "consultor" | "footer" }
  | {
      event: "pricing_plan_clicked";
      plan_name: string;
      billing_cycle: string;
      authenticated: boolean;
    }
  | {
      event: "begin_checkout";
      plan_name: string;
      billing_cycle: string;
      value: number;
      currency: string;
      user_email: string;
    }
  | {
      event: "purchase";
      transaction_id: string;
      value: number;
      currency: string;
      plan_name: string;
      user_email: string;
    }
  | { event: "onboarding_completed" }
  | { event: "first_patient_created" }
  | { event: "trial_banner_cta_clicked" }
  | { event: "trial_expired_modal_shown"; user_role: string }
  | { event: "trial_expired_cta_clicked"; user_role: string };

export type UserContext = {
  user_id: string;
  user_role: UserSlice["type"];
  subscription_status: string;
  onboarding_completed: boolean;
};

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

function push(payload: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

export function track(payload: TrackEvent): void {
  push(payload);
}

let lastUserContextSignature: string | undefined;

export function pushUserContextFromUser(user: UserSlice): void {
  if (!user.id) {
    lastUserContextSignature = undefined;
    return;
  }

  const context: UserContext = {
    user_id: user.id,
    user_role: user.type,
    subscription_status: user.clinicSubscription?.status ?? "none",
    onboarding_completed: Boolean(user.onboardingCompletedAt)
  };

  const signature = [
    context.user_id,
    context.user_role,
    context.subscription_status,
    context.onboarding_completed
  ].join("|");
  if (signature === lastUserContextSignature) return;
  lastUserContextSignature = signature;

  push(context);
}
